export default __webpack_public_path__ + "static/media/blockimg-fb.de0dd0ce.png";